import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

const useMasteringModal = () => {
  const { showModal } = useGlobalModalContext();

  const showErrorModal = (title?: string, message?: string) =>
    showModal({
      type: "error_modal",
      props: {
        title: title,
        message: message,
      },
    });

  return {
    showErrorModal,
  };
};

export default useMasteringModal;
